import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Feed from "@/pages/Feed";
import Alerts from "@/pages/Alerts";
import Directory from "@/pages/Directory";
import Marketplace from "@/pages/Marketplace";
import Events from "@/pages/Events";
import Profile from "@/pages/Profile";
import AdminModeration from "@/pages/AdminModeration";
import Messages from "@/pages/Messages";
import Community from "@/pages/Community";

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth session hash BEFORE normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/login" element={<Layout><Login /></Layout>} />
      <Route path="/register" element={<Layout><Register /></Layout>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/feed" element={<Layout><Feed /></Layout>} />
      <Route path="/alerts" element={<Layout><Alerts /></Layout>} />
      <Route path="/directory" element={<Layout><Directory /></Layout>} />
      <Route path="/marketplace" element={<Layout><Marketplace /></Layout>} />
      <Route path="/events" element={<Layout><Events /></Layout>} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Layout><Profile /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/moderation"
        element={
          <ProtectedRoute>
            <Layout><AdminModeration /></Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<Navigate to="/admin/moderation" replace />} />
      <Route path="/community/:name" element={<Layout><Community /></Layout>} />
      <Route
        path="/messages"
        element={
          <ProtectedRoute>
            <Layout><Messages /></Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              classNames: {
                toast: "rounded-2xl border-black/5",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
